<template>
  <div>
    <div v-if="!prazos.length" class="panel">
      <div class="panel-block is-justify-content-center">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>Nenhum prazo.</p>
          </div>
        </section>
      </div>
    </div>

    <b-table v-if="prazos.length" :data="prazos" hoverable :mobile-cards="false">
      <b-table-column field="nome" label="Descrição" v-slot="props">
        {{ prazoNome(props.row) }}
        <small v-if="observacaoPrazo(props.row)" class="ml-2">
          <strong
            ><i>{{ observacaoPrazo(props.row) }}</i></strong
          >
        </small>
      </b-table-column>

      <b-table-column
        field="data_ate"
        style="display: flex; flex-wrap: nowrap"
        centered
        label="Período"
        :width="!mobile ? '350' : '50%'"
        v-slot="props"
      >
        {{ dataPrazo(props.row.data_de, props.row.data_ate) }}
        <p style="font-size: 0.85rem; color: #8b8b8b; margin-left: 5px">(Horário local)</p>
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { formatarDataSegundo } from '@/utils/format';

export default {
  name: 'PregaoPrazos',
  computed: {
    ...mapGetters('app', { mobile: 'mobile' }),
    ...mapGetters({
      ofertaCompra: 'obterOfertaCompra',
      prazos: 'obterOfertaCompraPrazos',
      isSineDieSuspended: 'isSineDieSuspended',
    }),
    ultimaSuspensaoPrazo() {
      for (let i = this.prazos.length - 1; i >= 0; i -= 1) {
        if (this.prazos[i].prazo_id === 19) {
          return this.prazos[i];
        }
      }

      return null;
    },
  },
  methods: {
    prazoNome(prazo) {
      if (this.isSineDieSuspended && prazo.prazo_id === 19) {
        return 'Suspensão Sine Die';
      }

      const nomesRecursais = {
        23: 'Razões de Recursos',
        24: 'Contrarrazões de Recursos',
        25: 'Julgamento de Recursos',
      };

      return nomesRecursais[prazo.prazo_id] || prazo.nome;
    },
    justificativaSuspensao(prazo) {
      if (prazo !== this.ultimaSuspensaoPrazo) {
        return null;
      }

      return (
        prazo.justificativa_suspensao ||
        (this.ofertaCompra && this.ofertaCompra.justificativa_suspensao) ||
        null
      );
    },
    observacaoPrazo(prazo) {
      if (prazo && prazo.observacao) {
        return prazo.observacao;
      }

      return this.justificativaSuspensao(prazo);
    },
    dataPrazo(dataDe, dataAte) {
      const dataDeFormatada = formatarDataSegundo(dataDe);
      const dataAteFormatada = dataAte ? formatarDataSegundo(dataAte) : '';
      if (dataDeFormatada === '') return dataAteFormatada;
      if (dataAteFormatada === '') return dataDeFormatada;
      if (dataAteFormatada === '') {
        return `${dataDeFormatada} a Data Indeterminada`;
      }
      return `${dataDeFormatada} a ${dataAteFormatada}`;
    },
  },
};
</script>
